import React from 'react'

import SDropDown from '@/components/common/SDropDown'
import ArrowSVG from '@/images/svgs/Arrow.svg?react'

/**
 * "Label · Value ▾" trigger + SDropDown panel (prototype `.selwrap`). Shared by
 * the leaderboard filter bar and the mobile "Section · <tab>" switcher.
 *
 *  - label:   optional prefix shown muted before the value (omit for value-only, Figma 3790:33277 mobile sheet)
 *  - dropUp:  open the panel above the trigger (bottom-docked bars)
 *  - size:    'md' (40px, desktop bar) | 'lg' (46px, mobile top bar / bottom sheet)
 */
export default function EventHubLabeledDropdown({
    label,
    options,
    value,
    onChange,
    size = 'md',
    className = '',
    dropUp = false,
    wrapperClassName = '',
    ariaLabel,
}) {
    const current = options.find((option) => option.value === value)

    return (
        <SDropDown
            options={options}
            value={value}
            onChange={onChange}
            placement="left"
            align="start"
            ellipsisLabel
            maxHeight="max-h-72"
            wrapperClassName={wrapperClassName}
            className={`w-[min(320px,calc(100vw-40px))] ${dropUp ? 'top-auto! bottom-[calc(100%+6px)]' : ''}`}
            trigger={({ open, toggle }) => (
                <button
                    type="button"
                    onClick={toggle}
                    aria-haspopup="listbox"
                    aria-expanded={open}
                    aria-label={ariaLabel}
                    className={`s-focus-ring flex w-full cursor-pointer items-center gap-2 rounded-[5px] border bg-white text-left transition-colors hover:bg-[#f7f7f9] ${
                        size === 'lg' ? 'h-[46px] pl-4 pr-3.5 text-[15px]' : 'h-10 pl-4 pr-3 text-[14px]'
                    } ${open ? 'border-[#272727]' : 'border-[#dbdadf]'} ${className}`}
                >
                    {label && (
                        <>
                            <span className="whitespace-nowrap text-black/50">{label}</span>
                            <span className="text-[#dbdadf]">·</span>
                        </>
                    )}
                    <span className="min-w-0 flex-1 truncate font-medium text-[#272727]">{current?.label ?? '—'}</span>
                    <ArrowSVG
                        className={`h-[7px] w-[14px] flex-none text-black/50 transition-transform ${
                            open ? '' : 'rotate-180'
                        }`}
                    />
                </button>
            )}
        />
    )
}
